import { InjectionToken, Injectable, Inject, Component, Input, Output, Renderer2, ElementRef, EventEmitter, ChangeDetectionStrategy, NgModule, defineInjectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
var DISQUS_SHORTNAME = new InjectionToken('DISQUS_SHORTNAME');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DisqusService = /** @class */ (function () {
    function DisqusService(shortname, _document) {
        this.shortname = shortname;
        this._document = _document;
    }
    Object.defineProperty(DisqusService.prototype, "DISQUS", {
        get: /**
         * @return {?}
         */
        function () {
            return this._document.defaultView.DISQUS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DisqusService.prototype, "disqus_config", {
        get: /**
         * @return {?}
         */
        function () {
            return this._document.defaultView.disqus_config;
        },
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            this._document.defaultView.disqus_config = config;
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */
    DisqusService.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [DISQUS_SHORTNAME,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    /** @nocollapse */ DisqusService.ngInjectableDef = defineInjectable({ factory: function DisqusService_Factory() { return new DisqusService(inject(DISQUS_SHORTNAME), inject(DOCUMENT)); }, token: DisqusService, providedIn: "root" });
DisqusService.ɵfac = function DisqusService_Factory(t) { return new (t || DisqusService)(ɵngcc0.ɵɵinject(DISQUS_SHORTNAME), ɵngcc0.ɵɵinject(DOCUMENT)); };
DisqusService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DisqusService, factory: function (t) { return DisqusService.ɵfac(t); }, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisqusService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [DISQUS_SHORTNAME]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
    return DisqusService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DisqusComponent = /** @class */ (function () {
    function DisqusComponent(renderer, el, dService) {
        this.renderer = renderer;
        this.el = el;
        this.dService = dService;
        /**
         * DISQUS events
         */
        this.newComment = new EventEmitter(true);
        this.ready = new EventEmitter(true);
        this.paginate = new EventEmitter(true);
    }
    /**
     * @return {?}
     */
    DisqusComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        /** Reset Disqus if any input changed */
        if (!this.dService.DISQUS) {
            this.addDisqusScript();
        }
        else {
            this.reset();
        }
    };
    /** Add DISQUS script */
    /**
     * Add DISQUS script
     * @return {?}
     */
    DisqusComponent.prototype.addDisqusScript = /**
     * Add DISQUS script
     * @return {?}
     */
    function () {
        /** Set DISQUS config */
        this.dService.disqus_config = this.getConfig();
        /** @type {?} */
        var disqusScript = this.renderer.createElement('script');
        disqusScript.src = "//" + this.dService.shortname + ".disqus.com/embed.js";
        disqusScript.async = true;
        disqusScript.type = 'text/javascript';
        this.renderer.setAttribute(disqusScript, 'data-timestamp', new Date().getTime().toString());
        this.renderer.appendChild(this.el.nativeElement, disqusScript);
    };
    /** Reset DISQUS with the new config */
    /**
     * Reset DISQUS with the new config
     * @return {?}
     */
    DisqusComponent.prototype.reset = /**
     * Reset DISQUS with the new config
     * @return {?}
     */
    function () {
        this.dService.DISQUS.reset({
            reload: true,
            config: this.getConfig()
        });
    };
    /** Create DISQUS config from the inputs */
    /**
     * Create DISQUS config from the inputs
     * @return {?}
     */
    DisqusComponent.prototype.getConfig = /**
     * Create DISQUS config from the inputs
     * @return {?}
     */
    function () {
        /** @type {?} */
        var self = this;
        return function () {
            this.page.identifier = self.identifier;
            this.page.url = self.validateUrl(self.url);
            this.page.title = self.title;
            this.category_id = self.category;
            this.language = self.language;
            /* Available callbacks are afterRender, onInit, onNewComment, onPaginate, onReady, preData, preInit, preReset */
            this.callbacks.onNewComment = [function (e) {
                    self.newComment.emit(e);
                }];
            this.callbacks.onReady = [function (e) {
                    self.ready.emit(e);
                }];
            this.callbacks.onPaginate = [function (e) {
                    self.paginate.emit(e);
                }];
        };
    };
    /**
     * @param {?} url
     * @return {?}
     */
    DisqusComponent.prototype.validateUrl = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        /** Validate URL input */
        if (url) {
            /** @type {?} */
            var r = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
            if (r.test(url)) {
                return url;
            }
            else {
                console.warn('[Disqus]: Invalid URL');
            }
        }
        /** DISQUS will fallback to "Window.location.href" when URL is undefined */
        return undefined;
    };
    /** @nocollapse */
    DisqusComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: DisqusService }
    ]; };
    DisqusComponent.propDecorators = {
        url: [{ type: Input }],
        identifier: [{ type: Input }],
        title: [{ type: Input }],
        category: [{ type: Input }],
        language: [{ type: Input }],
        newComment: [{ type: Output }],
        ready: [{ type: Output }],
        paginate: [{ type: Output }]
    };
DisqusComponent.ɵfac = function DisqusComponent_Factory(t) { return new (t || DisqusComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DisqusService)); };
DisqusComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DisqusComponent, selectors: [["disqus"]], inputs: { url: "url", identifier: "identifier", title: "title", category: "category", language: "language" }, outputs: { newComment: "newComment", ready: "ready", paginate: "paginate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature()], decls: 1, vars: 0, consts: [["id", "disqus_thread"]], template: function DisqusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisqusComponent, [{
        type: Component,
        args: [{
                selector: 'disqus',
                template: '<div id="disqus_thread"></div>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: DisqusService }]; }, { newComment: [{
            type: Output
        }], ready: [{
            type: Output
        }], paginate: [{
            type: Output
        }], url: [{
            type: Input
        }], identifier: [{
            type: Input
        }], title: [{
            type: Input
        }], category: [{
            type: Input
        }], language: [{
            type: Input
        }] }); })();
    return DisqusComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DisqusModule = /** @class */ (function () {
    function DisqusModule() {
    }
    /**
     * @param {?} shortname
     * @return {?}
     */
    DisqusModule.forRoot = /**
     * @param {?} shortname
     * @return {?}
     */
    function (shortname) {
        return {
            ngModule: DisqusModule,
            providers: [
                { provide: DISQUS_SHORTNAME, useValue: shortname }
            ]
        };
    };
DisqusModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DisqusModule });
DisqusModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DisqusModule_Factory(t) { return new (t || DisqusModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DisqusModule, { declarations: [DisqusComponent], exports: [DisqusComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisqusModule, [{
        type: NgModule,
        args: [{
                declarations: [DisqusComponent],
                exports: [DisqusComponent]
            }]
    }], function () { return []; }, null); })();
    return DisqusModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { DisqusModule, DISQUS_SHORTNAME, DisqusService, DisqusComponent as ɵa };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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